import type { Error as DomainError } from '@/lib/api/generated/model';

const GENERIC_MESSAGE = "Couldn't update relations. Try again.";

/**
 * The backend's global error handler emits a stable domain-error envelope,
 * `{ error: "<CODE>", message?: string }`, for every refusal on the
 * create/delete relation endpoints (research.md D5). FR-010 requires the
 * cycle and duplicate cases to read as specific refusals, not a generic
 * failure — everything else, known or not, falls back to one message.
 */
export function mapTaskRelationError(error: DomainError | undefined): string {
  switch (error?.error) {
    case 'TASK_RELATION_CYCLE':
      return 'That would create a circular relationship.';
    case 'TASK_RELATION_ALREADY_EXISTS':
      return 'These tasks are already related.';
    case 'INVALID_SELF_RELATION':
      return "A task can't be related to itself.";
    case 'CROSS_WORKSPACE_TASK_RELATION':
      return 'That task is in a different workspace.';
    case 'TASK_NOT_FOUND':
      return "That task couldn't be found — it may have been deleted.";
    default:
      return GENERIC_MESSAGE;
  }
}
